export function usersFromGroup (state) {
  return groupName => state.users[groupName] || []
}

export function formsForUser (state) {
  return uid => state.userForms[uid] || []
}

export function getGroupByName (state) {
  return (name) => state.groups.find(g => g.name === name)
}

export function getUserById (state) {
  return (userId, groupName) => {
    const groupUsers = state.users[groupName]
    return groupUsers !== undefined ? groupUsers.find(u => u.uh === userId) : {}
  }
}

export function getAllUsers (state) {
  return state.groups.reduce((users, group) => users.concat(group.users), [])
}

export function getTasks (state) {
  return state.tasks
}
